export const rootStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px',
  cursor: 'pointer',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const activeRootStyles = {
  ...rootStyles,
  backgroundColor: 'action.selected',
};

export const textGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
};

export const titleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const lastMessagePreviewStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: 'text.secondary',
};

export const lastMessageUnreadStyles = {
  ...lastMessagePreviewStyles,
  color: 'text.primary',
};

export const typingPreviewStyles = {
  ...lastMessagePreviewStyles,
  color: 'primary.main',
  fontStyle: 'italic',
};

export const unreadBadgeStyles = {
  minWidth: 20,
  height: 20,
  borderRadius: '10px',
  padding: '0 6px',
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 1,
};
